export const SET_ADMIN_USER_DATA = 'SET_ADMIN_USER_DATA';
export const GET_ADMIN_USER_DATA = 'GET_ADMIN_USER_DATA';
export const CLEAR_ADMIN_USER_DATA = 'CLEAR_ADMIN_USER_DATA';
